const enemExceptions = /^\/enem(?:\/enem-digital)?\/?$/

export function visitableType (path) {
  return path.startsWith('/enem/') && !enemExceptions.test(path)
    ? 'manual_do_enem'
    : 'financial_aid'
}
